import { render, staticRenderFns } from "./SalesPopup.vue?vue&type=template&id=5406ef26&scoped=true&"
import script from "./SalesPopup.vue?vue&type=script&lang=js&"
export * from "./SalesPopup.vue?vue&type=script&lang=js&"
import style0 from "./SalesPopup.vue?vue&type=style&index=0&id=5406ef26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5406ef26",
  null
  
)

export default component.exports